import React from "react";
import { ModalComponent } from "../../../components/Modal.components";
import { PageTitle } from "../../../components/style";
import { Boxed } from "../../../components/Boxed.components";
import { Button } from "../../../components/Button.components";
import { Text } from "../../../components/Text.components";
export const ChangeRequestStatus = (props) => {
  console.log(props);
  // State props
  const { changeRequestModal, singleRequestData } = props;
  // Dispatch props
  const { closeModal, changeRequestForm } = props;

  console.log({ singleRequestData });

  return (
    <ModalComponent
      show={changeRequestModal}
      onHide={closeModal}
      title={<PageTitle margin="5px 0">{singleRequestData?.status === "active" ? "Deactivate" : "Activate"}{" "}Request Form</PageTitle>}
      footer={
        <Boxed display="flex" width="100%">
          <Button clear onClick={closeModal}>
            Cancel
          </Button>
          <Button
            margin="0 0 0 auto"
            color="#0E1E87"
            onClick={() =>
              changeRequestForm({
                data: {
                  status: `${
                    singleRequestData?.status === "active"
                      ? "inactive"
                      : "active"
                  }`,
                },
                id: singleRequestData?._id,
              })
            }
          >
            Confirm
          </Button>
        </Boxed>
      }
    >
      <Boxed>
        <Text>
          Are you sure you want to{" "}
          {singleRequestData?.status === "active" ? "deactivate" : "activate"}{" "}
          this request form? <br />
        </Text>
      </Boxed>
    </ModalComponent>
  );
};
